// Bing Maps adds and replaces its canvas layers after React renders.
export const observeMapCanvasAccessibility = (root, descriptionId) => {
  const labelCanvases = () => {
    root.querySelectorAll("canvas").forEach(canvas => {
      if (
        canvas.getAttribute("aria-hidden") === "true" ||
        canvas.getAttribute("aria-label")?.trim() ||
        canvas.getAttribute("aria-labelledby")?.trim() ||
        canvas.getAttribute("title")?.trim() ||
        canvas.textContent?.trim()
      )
        return

      canvas.setAttribute("aria-label", "Map of showroom locations")
      const descriptions = new Set(
        (canvas.getAttribute("aria-describedby") || "")
          .split(/\s+/)
          .filter(Boolean)
      )
      descriptions.add(descriptionId)
      canvas.setAttribute("aria-describedby", [...descriptions].join(" "))
    })
  }

  labelCanvases()
  const observer = new MutationObserver(labelCanvases)
  observer.observe(root, { childList: true, subtree: true })
  return () => observer.disconnect()
}
